export type ConsiderationValues = 'URBAN' | 'RURAL';

export const considerations: ConsiderationValues[] = ['URBAN', 'RURAL'];

enum CONSIDERATIONS {
  RURAL = 'Rural',
  URBAN = 'Urbain',
}
export default CONSIDERATIONS;
